/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      marginTop: 8,
    },
    containerBackground: {
      backgroundColor: colors.primary,
      borderRadius: 16,
      borderWidth: 4,
      borderColor: colors.primaryLight,
    },
    streakGraphTitle: { // @TODO: abstact with SummaryScreen styles
      fontSize: globalScale * 16,
      alignSelf: 'flex-start',
      color: colors.white,
      fontFamily: fonts.secondaryBold,
    },
  };
};

export default getStyles;
